var React = require('react');

function IcPlayButton32 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"currentColor","clipRule":"evenodd","d":"M2.66675 16.0013C2.66675 8.6413 8.64008 2.66797 16.0001 2.66797C23.3601 2.66797 29.3334 8.6413 29.3334 16.0013C29.3334 23.3613 23.3601 29.3346 16.0001 29.3346C8.64008 29.3346 2.66675 23.3613 2.66675 16.0013ZM21.3334 16.0013L13.3334 10.0013V22.0013L21.3334 16.0013Z"}));
}

IcPlayButton32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcPlayButton32;

IcPlayButton32.default = IcPlayButton32;
